class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.overlay = document.querySelector('.cart-notification__overlay');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    if (this.overlay) this.overlay.style.display = 'block';
    document.body.style.overflow = 'hidden';

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    // const notificationProductId = this.querySelector('.notification-product-id');
    // if (notificationProductId) {
    //   const productId = notificationProductId.dataset.productId;
    //   const recommendations = this.querySelector('product-recommendations');
    //   recommendations.dataset.productId = productId;
    //   recommendations.initializeRecommendations(productId);
    // }

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    if (this.overlay) this.overlay.style.display = 'none';
    document.body.style.overflow = '';

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

	renderContents(parsedState) {
		if (!parsedState || !parsedState.key || !parsedState.sections) return;

		this.cartItemKey = parsedState.key;

		const sectionsToRender = this.getSectionsToRender?.();
		if (Array.isArray(sectionsToRender)) {
			sectionsToRender.forEach((section) => {
				const sectionHTML = parsedState.sections[section.id];
				const targetElement = document.getElementById(section.id);

				if (sectionHTML && targetElement) {
					targetElement.innerHTML = this.getSectionInnerHTML?.(sectionHTML, section.selector) || '';
				}
			});
		}

		if (this.header?.reveal) this.header.reveal();
		if (this.open) this.open();
	}

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-recommended-product',
        selector: `[id="cart-notification-recommended-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
